export default "__VITE_ASSET__BfHT0V_D__"